import { AdditionalSVGProps } from '@/models/Svg';

export const ArrowLeftIcon = (
  props: React.SVGAttributes<SVGElement> & AdditionalSVGProps,
) => {
  const { className, fill = '#010F1D', ...rest } = props;

  return (
    <svg
      width='16'
      height='10'
      viewBox='0 0 16 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...rest}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.53033 1.53033C5.82322 1.23744 5.82322 0.762563 5.53033 0.46967C5.23744 0.176777 4.76256 0.176777 4.46967 0.46967L0.46967 4.46967C0.397763 4.54158 0.343509 4.62445 0.306909 4.71291C0.270239 4.80134 0.25 4.89831 0.25 5C0.25 5.10169 0.270239 5.19866 0.306909 5.28709C0.308569 5.2911 0.310265 5.2951 0.311997 5.29909C0.348465 5.38304 0.401023 5.46168 0.46967 5.53033L4.46967 9.53033C4.76256 9.82322 5.23744 9.82322 5.53033 9.53033C5.82322 9.23744 5.82322 8.76256 5.53033 8.46967L2.81066 5.75H15C15.4142 5.75 15.75 5.41421 15.75 5C15.75 4.58579 15.4142 4.25 15 4.25H2.81066L5.53033 1.53033Z'
        fill={fill}
      />
    </svg>
  );
};
